module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-blogs"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, [_c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })])])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Blogs")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Blogs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/128x128.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('strong', [_vm._v("John Smith")]), _vm._v(" "), _c('small', [_vm._v("@johnsmith")]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis.\n          ")])]), _vm._v(" "), _c('nav', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('a', {
    staticClass: "level-item",
    staticStyle: {
      "padding": "5px",
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("reply")])])]), _vm._v(" "), _c('a', {
    staticClass: "level-item",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")])])]), _vm._v(" "), _c('a', {
    staticClass: "level-item",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("favorite")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    staticClass: "is-active"
  }, [_c('a', [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Most Popular")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Most Viewed")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/1280x960.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/96x96.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("John Smith")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("@johnsmith")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n              This is a card design, no lorem ipsum anymore! consectetur adipiscing elit.\n              Phasellus nec iaculis mauris. "), _c('a', [_vm._v("@bulmaio")]), _vm._v(".\n              "), _c('a', [_vm._v("#css")]), _vm._v(" "), _c('a', [_vm._v("#responsive")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("11:09 PM - 1 Jan 2016")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Two")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-6 is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Three")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Three")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-6 is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Four")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Five")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Five")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Six")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Six")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Seven")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Seven")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6e3ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_test/Blogs.vue
// module id = 832
// module chunks = 1